import { Form, Formik } from "formik";
import React, { FC, ReactElement, useState } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import WizardSideBarStep from "@/models/WizardSideBarStep";
import { saveBioEventAction } from "@/services/bioEventActionService";
import { getErrorMessage } from "@/services/utilities/ServiceError";
import { useDialog } from "@/components/dialog/DialogContext";
import WizardTwo from "@/components/wizard/wizardTwo";
import AssignStep from "./AssignStep";
import SummaryStep from "./SummaryStep";

interface BioEventActionModalProps {
    isOpen: boolean;
    onClose: () => void;
    setBusy: React.Dispatch<React.SetStateAction<boolean>>;
    terminalId: string;
    bioAddressId: string;
    eventTypeId: string;
    eventTypeLabel: string;
}

const BioEventActionModal: FC<BioEventActionModalProps> = ({isOpen, onClose, setBusy, terminalId, bioAddressId, eventTypeId, eventTypeLabel }) => {
    const initialValues = {
        selectedAction: null,
    };

    const { translate } = useLocale();
    const dialog = useDialog();
    const [currentStep, setCurrentStep] = useState(0);
    const [stepDescriptions, setStepDescriptions] = useState<{ [key: string]: string }>({
        step1: "",
        step2: "",
    });

    const steps: WizardSideBarStep[] = [
        {
            title: translate.byKey(TranslationKeys.actions),
            description: stepDescriptions.step1,
            substeps: [],
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: "",
            substeps: [],
        },
    ];

    const onLocalNext = (e: any) => {
        setCurrentStep(currentStep + 1);
    }
    const onLocalBack = (e: any) => {
        setCurrentStep(currentStep - 1);
    }

    const stepContent: ReactElement[] = [
        <AssignStep key='1' onNext={onLocalNext} setStepDescriptions={setStepDescriptions} bioAddressId={bioAddressId} />,
        <SummaryStep key='2' onBack={onLocalBack} />,
    ];

    const handleClose = () => {
        setCurrentStep(0);
        setStepDescriptions({ step1: "", step2: "" });
        onClose();
    };

    const onSubmit = async (values: any) => {
        if (!eventTypeId) {
            toast.warn(translate.byKey(TranslationKeys.selectEventTypeFirst));
            return;
        }

        setBusy(true);
        saveBioEventAction(terminalId, bioAddressId, eventTypeId, values.selectedAction.id.toString()).then(() => {
            toast.success(translate.byKey(TranslationKeys.success));
            handleClose();
        }).catch((error) => {
            dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(error) });
        }).finally(() => {
            setBusy(false);
        })
    };

    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none w-content">
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={onSubmit}>
                <Form>
                    <WizardTwo
                        name={translate.byKeyFormatted(TranslationKeys.assignBioEventAction, { label: eventTypeLabel })}
                        step={currentStep}
                        onClose={handleClose}
                        sidebarSteps={steps}
                        stepContent={stepContent} />
                </Form>
            </Formik>
        </Modal>
    );
};

export default BioEventActionModal;